export enum OutgoingInvoiceCreationMethodEnum {
  AUTOMATICALLY = 'automatically',
  ON_SCHEDULE = 'on_schedule',
  MANUALLY = 'manually',
}
